import React__default, { forwardRef } from 'react';
import clsx from 'clsx';

const CardV2 = forwardRef(({ title, imageConfig, actionConfig, children, classes = {}, className, ...divProps }, ref) => {
    const classPrefix = 'c-card';
    return (React__default.createElement("div", { ...divProps, className: clsx(classPrefix, className, classes.card), ref: ref },
        !!imageConfig && !!imageConfig.url && (React__default.createElement("img", { className: clsx(`${classPrefix}__image`, classes.image), src: imageConfig.url, alt: imageConfig.alt })),
        React__default.createElement("div", { className: clsx(`${classPrefix}__content`, classes.content) },
            !!title && React__default.createElement("div", { className: clsx(`${classPrefix}__title`, classes.title) }, title),
            children,
            !!actionConfig && !!actionConfig.title && (React__default.createElement("div", { className: clsx(`${classPrefix}__cta`, classes.action) },
                React__default.createElement("a", { href: actionConfig.url },
                    React__default.createElement("p", null, actionConfig.title)))))));
});

export { CardV2, CardV2 as default };
//# sourceMappingURL=index.js.map
